import * as React from "react";

function SvgBackArrowIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={20}
      height={20}
      {...props}
    >
      <defs>
        <path
          d="M20 10.96H3.91l7.69 7.69L10.24 20l-10-10 10-10 1.36 1.35-7.69 7.69H20v1.92z"
          id="back-arrow-icon_svg__a"
        />
      </defs>
      <use xlinkHref="#back-arrow-icon_svg__a" fill="#dedede" />
      <use
        xlinkHref="#back-arrow-icon_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
    </svg>
  );
}

export default SvgBackArrowIcon;
